export enum FontGroups {
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
  panelTitle = 'panelTitle',
  inputLabel = 'inputLabel',
  input = 'input',
  inputGoalLabel = 'inputGoalLabel',
  inputGoal = 'inputGoal',
  street = 'propertyStreet',
  propertySign = 'propertySign',
  propertySignForSale = 'propertySignForSale',
}
